import React, { useState } from 'react';
import { Branding, Copyright } from './Layout';

const Registration = ({ onComplete, initialEmail, initialData, loading }) => {
    const [form, setForm] = useState({
        firstName: initialData?.firstName || '',
        lastName: initialData?.lastName || '',
        birthDate: initialData?.birthDate || '',
        sex: initialData?.sex || '',
        phone: initialData?.phone || '',
        instagram: initialData?.instagram || '',
        facebook: initialData?.facebook || ''
    });

    const handleDateChange = (e) => {
        let val = e.target.value.replace(/\D/g, ''); // Remove non-digits
        if (val.length > 8) val = val.substring(0, 8);
        
        let formatted = '';
        if (val.length > 0) {
            formatted += val.substring(0, 2);
            if (val.length > 2) {
                formatted += '/' + val.substring(2, 4);
                if (val.length > 4) {
                    formatted += '/' + val.substring(4, 8);
                }
            }
        }
        setForm({...form, birthDate: formatted});
    };

    const handleSubmit = (e) => {
        e.preventDefault();
        onComplete(form);
    };

    return (
        <div className="card glass-premium border-0 p-5 text-center fade-in-up mx-auto" style={{ maxWidth: '500px', borderRadius: '45px' }}>
            <Branding />
            <form onSubmit={handleSubmit} className="text-start">
                <h3 className="fw-900 mb-4 text-center text-pink-600">COMPLETA IL TUO PROFILO</h3>
                <div className="row g-3">
                    <div className="col-6">
                        <label className="form-label small fw-900 text-muted ms-2">NOME *</label>
                        <input type="text" className="form-control form-control-premium" value={form.firstName} onChange={(e) => setForm({...form, firstName: e.target.value})} required />
                    </div>
                    <div className="col-6">
                        <label className="form-label small fw-900 text-muted ms-2">COGNOME *</label>
                        <input type="text" className="form-control form-control-premium" value={form.lastName} onChange={(e) => setForm({...form, lastName: e.target.value})} required />
                    </div>
                    <div className="col-6">
                        <label className="form-label small fw-900 text-muted ms-2">DATA NASCITA *</label>
                        <input 
                            type="text" 
                            className="form-control form-control-premium text-center fw-700" 
                            placeholder="GG/MM/AAAA" 
                            value={form.birthDate} 
                            onChange={handleDateChange} 
                            maxLength="10"
                            required 
                        />
                    </div>
                    <div className="col-6">
                        <label className="form-label small fw-900 text-muted ms-2">SESSO *</label>
                        <select className="form-select form-control-premium" value={form.sex} onChange={(e) => setForm({...form, sex: e.target.value})} required>
                            <option value="">Scegli...</option>
                            <option value="male">Uomo</option>
                            <option value="female">Donna</option>
                        </select>
                    </div>
                    <div className="col-12">
                        <label className="form-label small fw-900 text-muted ms-2">TELEFONO (OPZIONALE)</label>
                        <input type="text" className="form-control form-control-premium" value={form.phone} onChange={(e) => setForm({...form, phone: e.target.value})} />
                    </div>
                    <div className="col-6">
                        <label className="form-label small fw-900 text-muted ms-2">INSTAGRAM (OPZIONALE)</label>
                        <input type="text" className="form-control form-control-premium" placeholder="@username" value={form.instagram} onChange={(e) => setForm({...form, instagram: e.target.value})} />
                    </div>
                    <div className="col-6">
                        <label className="form-label small fw-900 text-muted ms-2">FACEBOOK (OPZIONALE)</label>
                        <input type="text" className="form-control form-control-premium" value={form.facebook} onChange={(e) => setForm({...form, facebook: e.target.value})} />
                    </div>
                </div>
                <button 
                    type="submit" 
                    className="btn btn-lg w-100 py-3 mt-4 text-white fw-900 shadow-lg" 
                    style={{ borderRadius: '25px', background: 'linear-gradient(45deg, #db2777, #f43f5e)', border: 'none' }} 
                    disabled={loading}
                >
                    {loading ? <i className="fas fa-spinner fa-spin"></i> : 'REGISTRATI'}
                </button>
            </form>
            <Copyright />
        </div>
    );
};

export default Registration;
